import React from 'react';
import PropTypes from 'prop-types';
import CloseButton from '../../common/CloseButton/CloseButton';
import '../../common/CommonText.css'
import './Delete.css';

const DeletePopup = ({ isOpen,   onSave, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup archive-popup popup2">
        <div className='archive-heading delete-heading'>
          <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.2001 2.41931L29.2516 19.1609C30.6961 21.5655 29.9866 24.729 27.6661 26.226C26.8877 26.7313 25.9796 27.0002 25.0516 27H4.94701C2.21551 27 0 24.705 0 21.8715C0 20.913 0.259501 19.9754 0.747002 19.1609L10.8 2.41931C12.243 0.0147877 15.294 -0.721718 17.6145 0.775294C18.2566 1.1893 18.7996 1.7518 19.2001 2.41931ZM15 21C15.3979 21 15.7794 20.8419 16.0607 20.5606C16.342 20.2793 16.5 19.8978 16.5 19.4999C16.5 19.1021 16.342 18.7206 16.0607 18.4393C15.7794 18.158 15.3979 17.9999 15 17.9999C14.6022 17.9999 14.2207 18.158 13.9394 18.4393C13.6581 18.7206 13.5 19.1021 13.5 19.4999C13.5 19.8978 13.6581 20.2793 13.9394 20.5606C14.2207 20.8419 14.6022 21 15 21ZM15 7.49985C14.6022 7.49985 14.2207 7.65788 13.9394 7.93919C13.6581 8.2205 13.5 8.60203 13.5 8.99986V14.9999C13.5 15.3977 13.6581 15.7793 13.9394 16.0606C14.2207 16.3419 14.6022 16.4999 15 16.4999C15.3979 16.4999 15.7794 16.3419 16.0607 16.0606C16.342 15.7793 16.5 15.3977 16.5 14.9999V8.99986C16.5 8.60203 16.342 8.2205 16.0607 7.93919C15.7794 7.65788 15.3979 7.49985 15 7.49985Z" fill="white"/>
          </svg>
          <h6 className='confirm-archive common-text fts-15 ftw-4 white'>Confirmation Required</h6>
        </div>
        <div className='archive-content'>
            <p className='common-text fts-18 ftw-5 dk-gray delete-heading-text'>Are you sure you want to Delete?</p>
            <p  className='common-text fts-12 ftw-4 lt-gray'>
            Are you sure you want to delete this record? Once deleted, the data will be permanently
            </p>
            <p  className='common-text fts-12 ftw-4 lt-gray'> removed and may impact ongoing customer interactions</p>
        </div>
        <div className='archive-popup-buttons'>
          <button className='yes-button delete-button common-text fts-15 ftw-4 white' onClick={onSave}>Delete</button>
          <button className='no-button common-text fts-15 ftw-4 black' onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

DeletePopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DeletePopup;
